module.exports = __webpack_public_path__ + "img/juicymarbles.9ef2ac3e.png";